import { Route, Routes } from 'react-router-dom';

import CampaignsLayout from '@/src/modules/CampaignsModule/layouts/CampaignsLayout';
import { CampaignsMain } from '@/src/modules/CampaignsModule/screens/CampaignsMain';

export const CampaignsModuleRouter = () => (
  <Routes>
    <Route element={<CampaignsLayout />} path="/">
      <Route index element={<CampaignsMain />} />
    </Route>
  </Routes>
);
